import { AccessGroup } from '@/security/entities/AccessGroup';
import { Contact } from '@/security/entities/Contact';
export function toAssigneeSelectOption(assignee) {
    return {
        value: assignee.getAssigneeId(),
        label: assignee.name,
        data: assignee,
        description: assignee instanceof Contact ? assignee.description : undefined,
    };
}
export function isEmailInOptions(email, options) {
    return options.some((option) => {
        if (option instanceof AccessGroup) {
            return false;
        }
        return option.email?.toLowerCase() === email.trim().toLowerCase();
    });
}
export const defaultIsEmailAllowed = () => true;
